exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-freeword[data-v-c026b17e]{max-width:300px}.c-freeword .c-freeword__btn[data-v-c026b17e]{cursor:pointer}", ""]);

// exports
